"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _reactSpring = require("react-spring");

var _reactUseMeasure = _interopRequireDefault(require("react-use-measure"));

var _resizeObserver = require("@juggle/resize-observer");

var _reactDom = require("react-dom");

var _useUtils = require("../../_helpers/use-utils");

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./Tooltip.css");

var _styles = {
  "tooltip": "Tooltip__tooltip___12ZCM",
  "top": "Tooltip__top___1Aq6f",
  "right": "Tooltip__right___UVgDV",
  "bottom": "Tooltip__bottom___39iZo",
  "left": "Tooltip__left___Ecp9v"
};

const styles = _bind.default.bind(_styles);

const TOOLTIP_SIZE = 6;
const TooltipPopup = (0, _mobxReact.observer)(({
  dataTestId,
  className,
  text,
  show,
  sourceRect,
  position
}) => {
  const composed_classnames = (0, _bind.default)(styles('tooltip', position), className);
  const [ref, {
    width: tooltipWidth,
    height: tooltipHeight
  }] = (0, _reactUseMeasure.default)({
    polyfill: _resizeObserver.ResizeObserver
  });
  const [springStyles, animate] = (0, _reactSpring.useSpring)(() => ({
    opacity: 0,
    display: 'none',
    top: 'auto',
    left: 'auto',
    transform: 'none'
  }));
  const activeShowRef = (0, _react.useRef)(show);
  activeShowRef.current = show;
  (0, _react.useEffect)(() => {
    const props = {};
    const scrollOffset = document.documentElement.scrollTop;

    if (position === 'top') {
      props.top = `${scrollOffset + sourceRect.y - tooltipHeight - TOOLTIP_SIZE}px`;
      props.left = `${sourceRect.x + sourceRect.width / 2}px`;
      props.transform = `translate(-50%, 0)`;
    } else if (position === 'right') {
      props.top = `${scrollOffset + sourceRect.y + sourceRect.height / 2}px`;
      props.left = `${sourceRect.x + sourceRect.width + TOOLTIP_SIZE}px`;
      props.transform = `translate(0, -50%)`;
    } else if (position === 'bottom') {
      props.top = `${scrollOffset + sourceRect.y + sourceRect.height + TOOLTIP_SIZE}px`;
      props.left = `${sourceRect.x + sourceRect.width / 2}px`;
      props.transform = `translate(-50%, 0)`;
    } else if (position === 'left') {
      props.top = `${scrollOffset + sourceRect.y + sourceRect.height / 2}px`;
      props.left = `${sourceRect.x - tooltipWidth - TOOLTIP_SIZE}px`;
      props.transform = `translate(0, -50%)`;
    }

    animate.set(props);
  }, [sourceRect, tooltipWidth, tooltipHeight]);
  (0, _react.useEffect)(() => {
    if (activeShowRef.current) {
      animate.set({
        display: 'block'
      });
      animate.start({
        opacity: 1
      });
    } else {
      animate.start({
        opacity: 0
      })[0].then(() => {
        if (!activeShowRef.current) {
          animate.set({
            display: 'none'
          });
        }
      });
    }
  }, [show]);
  return (0, _reactDom.createPortal)(_react.default.createElement(_reactSpring.animated.div, {
    ref: ref,
    className: composed_classnames,
    "data-testid": dataTestId,
    style: springStyles
  }, text), document.body);
});
const Tooltip = (0, _mobxReact.observer)(({
  className,
  toolTipClassName,
  text,
  position = 'top',
  children,
  dataTestId
}) => {
  const sourceElementRef = (0, _react.useRef)(null);
  const [show, setShow] = (0, _react.useState)(false);
  const [sourceRect, setSourceRect] = (0, _react.useState)({
    width: 0,
    height: 0,
    x: 0,
    y: 0
  });

  const showTooltip = () => {
    if (sourceElementRef.current) {
      setSourceRect(sourceElementRef.current.getBoundingClientRect());
      setShow(true);
    } else {
      setShow(false);
    }
  };

  const hideTooltip = () => {
    setShow(false);
  };

  (0, _useUtils.useDocumentEvent)('scroll', hideTooltip, true);
  return _react.default.createElement("span", {
    ref: sourceElementRef,
    className: className,
    "data-testid": dataTestId,
    onMouseEnter: showTooltip,
    onMouseLeave: hideTooltip
  }, children, _react.default.createElement(TooltipPopup, {
    dataTestId: dataTestId && `${dataTestId}-popup`,
    className: toolTipClassName,
    position: position,
    show: show,
    sourceRect: sourceRect,
    text: text
  }));
});
Tooltip.defaultProps = {
  position: 'right'
};
var _default = Tooltip;
exports.default = _default;